import React from 'react'
import {
    Container,
    CircularProgress,
    Avatar,
    Box,
    Typography,
} from '@mui/material'
import { Slide, Fade } from 'react-awesome-reveal'
import { useConfig } from '../../hooks/useConfig'

const About: React.FC = () => {
    const { config, loading } = useConfig()

    if (loading || !config) {
        return (
            <Container
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    minHeight: '50vh',
                }}
            >
                <CircularProgress />
            </Container>
        )
    }

    return (
        <Container
            sx={{
                py: 8,
                minHeight: '100vh',
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    mb: 6,
                }}
            >
                <Fade triggerOnce>
                    <Slide direction="down" triggerOnce>
                        <Typography
                            variant="h2"
                            component="h2"
                            sx={{
                                fontSize: { xs: '2rem', md: '3rem' },
                                fontWeight: 700,
                                mb: 4,
                                color: 'primary.main',
                            }}
                        >
                            {config.about.title}
                        </Typography>
                    </Slide>
                </Fade>
                <Avatar
                    alt="David LiaBraaten"
                    src="/image/profile-192x192.png"
                    sx={{
                        width: 192,
                        height: 192,
                        m: 4,
                        animation: 'fadeIn 0.6s ease-in 0.2s both',
                        '@keyframes fadeIn': {
                            from: { opacity: 0 },
                            to: { opacity: 1 },
                        },
                    }}
                />
            </Box>

            <Box
                sx={{
                    animation: 'fadeIn 0.6s ease-in 0.4s both',
                    '@keyframes fadeIn': {
                        from: { opacity: 0 },
                        to: { opacity: 1 },
                    },
                }}
            >
                <Typography
                    variant="h3"
                    component="h3"
                    sx={{
                        fontSize: { xs: '1.5rem', md: '2rem' },
                        fontWeight: 600,
                        mb: 2,
                        mt: 4,
                        color: 'primary.main',
                    }}
                >
                    {config.about.work.title}
                </Typography>
                <Typography
                    variant="body1"
                    component="p"
                    sx={{
                        textAlign: 'left',
                        mb: 4,
                        lineHeight: 1.8,
                        color: 'text.secondary',
                    }}
                >
                    {config.about.work.content}
                </Typography>
            </Box>

            <Box
                sx={{
                    animation: 'fadeIn 0.6s ease-in 0.6s both',
                    '@keyframes fadeIn': {
                        from: { opacity: 0 },
                        to: { opacity: 1 },
                    },
                }}
            >
                <Typography
                    variant="h3"
                    component="h3"
                    sx={{
                        fontSize: { xs: '1.5rem', md: '2rem' },
                        fontWeight: 600,
                        mb: 2,
                        mt: 4,
                        color: 'primary.main',
                    }}
                >
                    {config.about.life.title}
                </Typography>
                <Typography
                    variant="body1"
                    component="p"
                    sx={{
                        textAlign: 'left',
                        lineHeight: 1.8,
                        color: 'text.secondary',
                    }}
                >
                    {config.about.life.content}
                </Typography>
            </Box>
        </Container>
    )
}

export default About
